import { render, staticRenderFns } from "./BrandStory2.vue?vue&type=template&id=61e76ff8&"
import script from "./BrandStory2.vue?vue&type=script&lang=js&"
export * from "./BrandStory2.vue?vue&type=script&lang=js&"
import style0 from "./BrandStory2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports